import { render, staticRenderFns } from "./rewardDealApproval.vue?vue&type=template&id=a9848ef6"
import script from "./rewardDealApproval.vue?vue&type=script&lang=js"
export * from "./rewardDealApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports